import axiosClient from "../../../../axiosClient"

export default async (id) => {
    const result = await axiosClient.get(`/background-check/${id}`)
    return result.data
}
